import React from 'react';
import { ChevronLeft, ChevronRight, User, Users } from 'lucide-react';
import useSlideAnimation from '../../../hooks/useSlideAnimation';
import SlidePanel from '../../SliderPage/SlidePanel';
import ProjectManager from './ProjectMaster';
import LegacyProjectManager from './LegacyProjectMaster';

const SliderPageProject = () => {
  const { activePanel, slideDirection, slideTo } = useSlideAnimation(0);

  const panels = [
    {
      id: 0,
      title: 'Project Management',
      subtitle: 'Manage Project',
      icon: <Users size={18} />,
      component: <ProjectManager />,
    },
    {
      id: 1,
      title: 'Legacy Project Management',
      subtitle: 'Manage Legacy Project',
      icon: <User size={18} />,
      component: <LegacyProjectManager />,
    },
  ];

  const handlePrevSlide = () => {
    if (activePanel > 0) {
      slideTo(activePanel - 1);
    }
  };

  const handleNextSlide = () => {
    if (activePanel < panels.length - 1) {
      slideTo(activePanel + 1);
    }
  };

  return (
    <div className="flex flex-col min-h-screen bg-white">
      {/* Header with Tabs */}
      <div className="flex overflow-x-auto border-b border-gray-200 p-2 bg-gray-50 gap-3">

        {panels.map((panel, index) => (
          <button
            key={panel.id}
            onClick={() => slideTo(index)}
            className={`flex items-center gap-2 px-4 py-2 rounded-lg whitespace-nowrap transition-all
              ${activePanel === index ? 'bg-primary text-white' : 'hover:bg-gray-200 text-gray-700'}
            `}
          >
            <div>{panel.icon}</div>
            <div className="flex flex-col text-left">
              <span className="text-sm font-semibold truncate">{panel.title}</span>
              <span className="text-xs opacity-70 truncate">{panel.subtitle}</span>
            </div>
          </button>
        ))}
      </div>

      {/* Content Area */}
      <div className="flex flex-col flex-1 min-h-0 relative">
        {/* Navigation Buttons */}
        <div className="absolute top-1/2 left-0 transform -translate-y-1/2 flex items-center space-x-2 px-2 z-10">
          <button
            onClick={handlePrevSlide}
            disabled={activePanel === 0}
            className={`p-2 rounded-full bg-white border shadow
              ${activePanel === 0 ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-100'}
            `}
            aria-label="Previous Slide"
          >
            <ChevronLeft size={20} />
          </button>
        </div>

        <div className="absolute top-1/2 right-0 transform -translate-y-1/2 flex items-center space-x-2 px-2 z-10">
          <button
            onClick={handleNextSlide}
            disabled={activePanel === panels.length - 1}
            className={`p-2 rounded-full bg-white border shadow
              ${activePanel === panels.length - 1 ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-100'}
            `}
            aria-label="Next Slide"
          >
            <ChevronRight size={20} />
          </button>
        </div>

        {/* Slide Panels */}
        <div className="flex-1 min-h-0">
          {panels.map((panel, index) => (
            <SlidePanel key={panel.id} isActive={activePanel === index} direction={slideDirection}>
              {panel.component}
            </SlidePanel>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SliderPageProject;
